import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { TradingSessionComponent } from '@zero/shared/ui-web-components';
import { BehaviorSubject, combineLatest, filter, firstValueFrom, map } from 'rxjs';
import { BaseComponent } from '../../components/base.component';
import { DocsComponent } from '../../components/docs/docs.component';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  selector: 'child-onboarding-conclusion-of-contract',
  imports: [TranslocoPipe, OnboardingContainerComponent, TradingSessionComponent, AsyncPipe, DocsComponent],
  templateUrl: './conclusion-of-contract.component.html',
})
export class ConclusionOfContractComponent extends BaseComponent {
  readonly #sessionAuthorized = new BehaviorSubject<boolean>(false);
  readonly #destroyRef = inject(DestroyRef);

  public readonly sessionAuthorized$ = this.#sessionAuthorized.asObservable();

  public setSessionAuthState = (sessionAuthorized: boolean) => this.#sessionAuthorized.next(sessionAuthorized);

  public readonly isFormValid$ = combineLatest([this.sessionAuthorized$, this.store.sendingContractConfirmation$]).pipe(
    map(([sessionAuthorized, sendingContractConfirmation]) => sessionAuthorized && !sendingContractConfirmation),
  );

  protected override async submit(): Promise<void> {
    (await firstValueFrom(this.isFormValid$)) && this.store.submitContract();
  }

  protected override populateFromData(): void {
    // do nothing here, as this component does not need to populate data from the store
  }

  protected override listenToSuccessfulSubmit(): void {
    this.store.sentContractConfirmationSuccessfully$
      .pipe(
        filter((sent) => sent),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => {
        this.service.goToNextStep();
      });
  }
}
